import {HiFire} from 'react-icons/hi'
import {MdPlaylistAdd} from 'react-icons/md'
import {SiYoutubegaming} from 'react-icons/si'

import NxtWatchContext from '../../NxtWatchContext/NxtWatchContext'
import Banner from '../Banner'
import NonHomeVideoItem from '../NonHomeVideoItem'
import GameVideoItem from '../GameVideoItem'

import {
  HeaderContainer,
  VideosListContainer,
  BgContainer,
  HeaderContent,
  IconComponent,
} from './styledComponents'

const NonHomePageVideosContainer = props => {
  const {category, videosList} = props

  return (
    <NxtWatchContext.Consumer>
      {value => {
        const {darkMode} = value

        const renderRespectiveIcon = () => {
          let resJsxIcon = ''
          if (category === 'Trending') {
            resJsxIcon = <HiFire />
          } else if (category === 'Saved Videos') {
            resJsxIcon = <MdPlaylistAdd />
          } else {
            resJsxIcon = <SiYoutubegaming />
          }
          return <IconComponent darkMode={darkMode}>{resJsxIcon}</IconComponent>
        }

        return (
          <BgContainer darkMode={darkMode}>
            <Banner />
            <HeaderContainer darkMode={darkMode}>
              {renderRespectiveIcon()}
              <HeaderContent darkMode={darkMode}>{category}</HeaderContent>
            </HeaderContainer>
            <VideosListContainer orientation={category === 'Gaming'}>
              {videosList.map(eachItem => {
                if (category === 'Gaming') {
                  return <GameVideoItem details={eachItem} key={eachItem.id} />
                }
                return <NonHomeVideoItem details={eachItem} key={eachItem.id} />
              })}
            </VideosListContainer>
          </BgContainer>
        )
      }}
    </NxtWatchContext.Consumer>
  )
}
export default NonHomePageVideosContainer
